/**
 * WPS Details Services - API service layer for WPS Detail operations
 * Handles CRUD operations for WPS detail records, process data, and related operations
 */
import axios from "axios";

// Dynamic API URL configuration based on environment
let GROOVE_API_URL;

if (process.env.REACT_APP_NODE_ENV === "local") {
  GROOVE_API_URL = process.env.REACT_APP_WPS_GROOVE_API_URL;
} else {
  GROOVE_API_URL = process.env.REACT_APP_API_URL + "wps";
}

/**
 * Get WPS details by ID - Used across multiple WPS components
 * Used in:
 * - WIGridPage.jsx - Get WPS details for WI operations
 * - General.jsx - Get old process data for WPS operations
 * - GrooveTransaction.jsx - Load WPS detail data
 * - Pdf_Download.jsx - Get data for PDF generation
 * - WPSTubesheetTransaction.jsx - Load tubesheet WPS details
 * @param {string} IddetailPK - Detail primary key (Project No)
 * @param {string} IddetailSK - Detail secondary key (WPS No)
 * @returns {Object} WPS detail record with process data
 */
export const getdetailsById = async (IddetailPK, IddetailSK) => {
  let url = `${GROOVE_API_URL}/WpsDetailsMast/getdetailsById`;
  let reqbody = { PK: IddetailPK, SK: IddetailSK };
  const response = await axios.post(url, reqbody)
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });

  return response.data;
};


/**
 * Get WPS details for WI (Welding Instruction) operations
 * Used in:
 * - AddEditWIPage.jsx - Load WPS data when creating/editing WI records
 * @param {string} IddetailPK - Detail primary key (Project No)
 * @param {string} IddetailSK - Detail secondary key (WPS No)
 * @returns {Object} WPS detail record formatted for WI operations
 */
export const getdetailsByIdWI = async (IddetailPK, IddetailSK) => {
  let url = `${GROOVE_API_URL}/WpsDetailsMast/forWI`;
  let reqbody = { PK: IddetailPK, SK: IddetailSK };
  const response = await axios.post(url, reqbody)
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });

  return response.data;
};

/**
 *  Add new WPS detail record
 * @param {Object} WPS_Details_Master - WPS detail data to add
 * @returns {Object} API response
 */
export const AddNewDetail = (WPS_Details_Master) => {
  let url = `${GROOVE_API_URL}/WpsDetailsMast`;
  try {
    const response = axios.post(url, WPS_Details_Master);

    return response;
  } catch (error) {
    console.error("Error in AddNewDetail:", error);
    return { message: "Unable to add detail", status: false };
  }
};

/**
 * Delete WPS detail record - Used in WPS General component
 * Used in:
 * - General.jsx - Delete WPS detail records when removing processes
 * @param {string} pkid - Primary key ID (Project No)
 * @param {string} skid - Secondary key ID (WPS No)
 * @returns {Object} Deletion response
 */
export async function DeleteWPS(pkid, skid) {
  let url = `${GROOVE_API_URL}/WpsDetailsMast/delete`;
  let body = { PK: pkid, SK: skid }
  const resp = await axios
    .post(url, body)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.message;
    });

  return resp;
}
